import React from 'react';
import {
  Document,
  PDFViewer,
  Page as PDFPage,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { formatDate } from '../../../../../utils'; // Assuming you have a formatDate function

const styles = {
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  contentContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 7,
    display: 'inline-block'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  columnHeader: {
    width: '20%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '20%',
    padding: 5,
    textAlign: 'center'
  }
};

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const COLORS = ['#f0f0f0', '#e0e0e0'];

export const StockStatusReportPdf = ({ data }) => {
  console.log('StockStatusReportPdf Data:', data);

  // Group the data by product and calculate totals
  const groupedData = data.reduce((acc, curr) => {
    const key = curr.product;

    if (acc[key]) {
      acc[key].totalQty += curr.totalQty;
      acc[key].totalAmount += curr.totalAmount;
      acc[key].totalGST += curr.totalGST;
      acc[key].totalMRP += curr.totalMRP;
      acc[key].totalBillAmount += curr.totalBillAmount;
    } else {
      acc[key] = { ...curr };
    }

    return acc;
  }, {});

  // Sort the data alphabetically by product name
  const sortedData = Object.values(groupedData).sort((a, b) => {
    if (a.productName < b.productName) return -1;
    if (a.productName > b.productName) return 1;
    return 0;
  });

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Item Wise Sale Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            {/* Hospital logo */}
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />

            {/* Date range */}
            <Text style={{ fontSize: '8px' }} content={`From Date : ${data.from_date} To Date : ${data.to_date}`} />

            {/* Table headers */}
            <View style={styles.row}>
              <Text style={styles.columnHeader} content="Sr" />
              <Text style={styles.columnHeader} content="Product Name" />
              <Text style={styles.columnHeader} content="Total Qty" />
              <Text style={styles.columnHeader} content="Total Amount" />
              <Text style={styles.columnHeader} content="Total GST" />
              <Text style={styles.columnHeader} content="Total MRP" />
              <Text style={styles.columnHeader} content="Total Bill Amount" />
            </View>

            {/* Display the sorted product data */}
            {sortedData.map((item, index) => (
              <View
                key={index}
                style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}
              >
                <Text style={styles.columnContent} content={index + 1} />
                <Text style={styles.columnContent} content={item.productName} />
                <Text style={styles.columnContent} content={item.totalQty} />
                <Text style={styles.columnContent} content={item.totalAmount} />
                <Text style={styles.columnContent} content={item.totalGST} />
                <Text style={styles.columnContent} content={item.totalMRP} />
                <Text style={styles.columnContent} content={item.totalBillAmount} />
              </View>
            ))}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default StockStatusReportPdf;
